export default {"src":"/_next/static/media/spotify.13cb9f83.svg","height":160,"width":660};